'use client';
import { useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';
import { METADATA_SITE_LOCALE } from '@sgcmpteltd/uikit-next/utils/metadata';
import NextError from 'next/error';

const GlobalError = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  if (error) {
    throw error;
  }

  return (
    <html lang={METADATA_SITE_LOCALE}>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
};

export default GlobalError;
